<template>
    <div>
        <div class="name-value-title pl-0 primary--text mb-2">
            {{ title }}
        </div>

        <!--
        <v-row dense class="primary white--text mt-1 mb-2" style=" border-top-left-radius: 4px; border-top-right-radius: 4px; font-size: 14px;">
            <v-col class="col-6 pl-2">
                Name
            </v-col>
            <v-col class="col-6">
                Inhalt
            </v-col>
        </v-row>
        -->
    </div>
</template>

<script>
export default {
    name: "CNameValueHeader",

    props: {
        title: {

        }
    }
}
</script>

<style scoped>


.name-value-title {
    font-size: 15px;
    font-weight: 600;
    border-bottom-style: solid;
    border-bottom-width: 1px;
}

</style>